import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentsComparisonTextOver: {
		id: 'software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-over',
		defaultMessage:
			'{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} over 12-week average',
		description:
			"Comparison between the selected week's production deployments and 12 week production deployment median",
	},
	deploymentsComparisonTextUnder: {
		id: 'software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-under',
		defaultMessage:
			'{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} under 12-week average',
		description:
			"Comparison between the selected week's production deployments and 12 week production deployment average",
	},
	deploymentsComparisonTextEqual: {
		id: 'software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-equal',
		defaultMessage: 'Equal to 12-week average',
		description:
			"Comparison between the selected week's production deployments and 12 week production deployment average",
	},
	issuesComparisonTextOver: {
		id: 'software-deployment-frequency-report.common.trend-summary.issues-comparison-text-over',
		defaultMessage:
			'{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} over 12-week median',
		description:
			"Comparison between the selected week's production issues and 12 week production issue median",
	},
	issuesComparisonTextUnder: {
		id: 'software-deployment-frequency-report.common.trend-summary.issues-comparison-text-under',
		defaultMessage:
			'{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} under 12-week median',
		description:
			"Comparison between the selected week's production issues and 12 week production issue median",
	},
	issuesComparisonTextEqual: {
		id: 'software-deployment-frequency-report.common.trend-summary.issues-comparison-text-equal',
		defaultMessage: 'Equal to 12-week median',
		description:
			"Comparison between the selected week's production issues and 12 week production issue median",
	},
	noDataFound: {
		id: 'software-deployment-frequency-report.common.trend-summary.no-data-found',
		defaultMessage: 'No data found',
		description: 'Display when there is no data found',
	},
	insufficientData: {
		id: 'software-deployment-frequency-report.common.trend-summary.insufficient-data',
		defaultMessage: 'Not enough data to establish a 12-week median',
		description:
			'Display when there is not enough data to display 12-week median, as it could be meaningless.',
	},
	noProdButOtherEnv: {
		id: 'software-deployment-frequency-report.common.trend-summary.no-prod-but-other-env',
		defaultMessage: 'No production deployment data',
		description:
			'Display when there is no prod data, but there are other environment deployment data',
	},
	issuesComparisonTextOverIssueTerminologyRefreshM4: {
		id: 'software-deployment-frequency-report.common.trend-summary.issues-comparison-text-over-issue-terminology-refresh-m4',
		defaultMessage:
			'{numIssuesDiff} {numIssuesDiff, plural, one {work item} other {work items}} over 12-week median',
		description:
			"Comparison between the selected week's production issues and 12 week production issue median",
	},
	issuesComparisonTextUnderIssueTerminologyRefreshM4: {
		id: 'software-deployment-frequency-report.common.trend-summary.issues-comparison-text-under-issue-terminology-refresh-m4',
		defaultMessage:
			'{numIssuesDiff} {numIssuesDiff, plural, one {work item} other {work items}} under 12-week median',
		description:
			"Comparison between the selected week's production issues and 12 week production issue median",
	},
});
